/* eslint-disable no-unused-vars, no-undef */
export const contains_subscription_plan = function (haystack) {
  let needle = 'input[name*="convert_to_sub"]';
  if (haystack.find(needle).length > 0) {
    return true;
  }
  return false;
}
export const isMobile = window.matchMedia('only screen and (max-width: 760px)').matches;

export default {
  init() {
    console.debug('init common');
    // JavaScript to be fired on all pages

    /* -------------------------------- Mobile stickyBar -------------------------------- */
    /* Commenting this out as it may be causing the header to shift off-screen on mobile
    if (isMobile) {
      var $stickyBar = jQuery('#dropdown-bar');
      if ($stickyBar.length > 0) {
        var stickyBarTopPosition = $stickyBar.offset().top;
        var $stickyBarParent = jQuery('#header');
        $stickyBarParent.css('top', -stickyBarTopPosition);
        $(window).scroll(stickyBar);
      }
    }
    */
    var modal;
    // Ya no se utiliza vanilla-lazyload o el chequeo manual ya que WP Rocket se encarga de todo esto.

    $('#new-button-login').hover(() => {
      $('#menu-login').removeClass('hidden');
    });

    function stickyBar() {
      if ($(window).scrollTop() > stickyBarTopPosition) {
        $stickyBar.addClass('is-sticky');
      } else {
        $stickyBar.removeClass('is-sticky');
      }
    }

    /* ------------------------------- IC Mobile Menu v3 (Premium) ------------------------------- */
    function buildBurgerMenu() {
      const $trigger = $('#open-main-mobile-overlay');
      const $container = $('#ic-mobile-menu-v2');
      const $panel = $('#ic-mobile-menu-panel');
      const $overlay = $('#ic-menu-overlay');
      const $close = $('#ic-menu-close');
      const $body = $('body');
      const $searchTrigger = $('#ic-menu-search-trigger');
      const $searchForm = $('#ic-menu-search-form');

      function openMenu() {
        $trigger.addClass('tham-active');
        $container.addClass('is-active is-open'); // namespace classes
        $body.addClass('mobile-menu-open');
      }

      function closeMenu() {
        $trigger.removeClass('tham-active');
        $container.removeClass('is-active is-open');
        $body.removeClass('mobile-menu-open');
        // Reset search form if closed
        $searchForm.removeClass('is-active');
      }

      $trigger.on('click', function (e) {
        e.preventDefault();
        if ($container.hasClass('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      // Close handlers
      $overlay.on('click', closeMenu);
      $close.on('click', closeMenu);
      $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $container.hasClass('is-open')) closeMenu();
      });

      // Search toggle
      $searchTrigger.on('click', function(e) {
        e.preventDefault();
        $searchForm.toggleClass('is-active');
        if ($searchForm.hasClass('is-active')) {
          $searchForm.find('input').focus();
        }
      });

      // Magic Link AJAX Handler
      $container.on('submit', '.js-magic-login-form', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $input = $form.find('.js-magic-email');
        const $msg = $container.find('.js-magic-message');
        const email = $.trim($input.val());
        const nonce = $form.data('nonce');

        if (!email) return;

        // Show spinner
        $('#mobile-menu-spinner').addClass('is-visible');
        $msg.hide().removeClass('is-success is-error');

        $.ajax({
          type: 'POST',
          url: (typeof wc_add_to_cart_params !== 'undefined') ? wc_add_to_cart_params.ajax_url : '/wp-admin/admin-ajax.php',
          data: {
            action: 'icml_send_magic_link',
            nonce: nonce,
            email: email,
            context: 'mobile_menu',
          },
          success: function (response) {
            $('#mobile-menu-spinner').removeClass('is-visible');
            if (response.success) {
              $form.hide();
              $msg.text(response.data.message || 'Check your inbox!').addClass('is-success').show();
            } else {
              $msg.text(response.data.message || 'Something went wrong.').addClass('is-error').show();
            }
          },
          error: function () {
            $('#mobile-menu-spinner').removeClass('is-visible');
            $msg.text('Network error. Please try again.').addClass('is-error').show();
          },
        });
      });

      // Spinner trigger for other internal links (categories and informational)
      $container.on('click', 'a', function (e) {
        // Don't show spinner if it's the close button, search trigger, or dashboard/orders links which are internal
        if ($(this).is('#ic-menu-close') || $(this).closest('#ic-menu-search-trigger').length) return;
        
        // Don't show for links with no href, hashes, or javascript
        const href = $(this).attr('href');
        if (!href || href === '#' || href.startsWith('javascript:')) return;

        $('#mobile-menu-spinner').addClass('is-visible');
      });
    }
    buildBurgerMenu();

    /* ------------------------------- Mobile Category Dropdowns ------------------------------- */
    function buildMobileCategoryDropdowns() {
      var $mobileBar = $('#mobile-category-bar');
      if (!$mobileBar.length) return;

      var $backdrop = $('#mobile-dropdown-backdrop');
      var $dropdownParents = $mobileBar.find('.has-dropdown');
      var closeTimer = null;
      var backdropTimer = null;

      function closeAllDropdowns(callback) {
        if (closeTimer) clearTimeout(closeTimer);
        if (backdropTimer) clearTimeout(backdropTimer);

        $dropdownParents.removeClass('mobile-dropdown-open');
        $mobileBar.find('.dropdown-menu').removeClass('mobile-dropdown-visible');
        $backdrop.removeClass('active');

        closeTimer = setTimeout(function () {
          $mobileBar.find('.dropdown-menu').css('display', 'none');
          closeTimer = null;
          if (callback) callback();
        }, 280);
        backdropTimer = setTimeout(function () {
          $backdrop.css('display', 'none');
          backdropTimer = null;
        }, 280);
      }

      function closeImmediately() {
        if (closeTimer) clearTimeout(closeTimer);
        if (backdropTimer) clearTimeout(backdropTimer);
        $dropdownParents.removeClass('mobile-dropdown-open');
        $mobileBar.find('.dropdown-menu').removeClass('mobile-dropdown-visible').css('display', 'none');
        $backdrop.removeClass('active').css('display', 'none');
      }

      function openDropdown($parent) {
        var $menu = $parent.children('.dropdown-menu');
        var headerBottom = $('#header')[0].getBoundingClientRect().bottom + window.scrollY;

        $parent.addClass('mobile-dropdown-open');
        $menu.css({
          display: 'grid',
          top: headerBottom + 'px',
        });
        $backdrop.css({ display: 'block' });

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            $menu.addClass('mobile-dropdown-visible');
            $backdrop.addClass('active');
          });
        });
      }

      $dropdownParents.children('a').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $parent = $(this).parent();

        if ($parent.hasClass('mobile-dropdown-open')) {
          closeAllDropdowns();
        } else {
          closeImmediately();
          openDropdown($parent);
        }
      });

      $backdrop.on('click', function () {
        closeAllDropdowns();
      });

      $mobileBar.find('.dropdown-menu a').on('click', function (e) {
        e.stopPropagation();
      });
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      buildMobileCategoryDropdowns();
    }

    /**
     * Accordion init
    */
    $('.accordion-wholehams').accordionjs({
      // Allow self close.(data-close-able)
      closeAble: false,
      // Close other sections.(data-close-other)
      closeOther: true,
      // Animation Speed.(data-slide-speed)
      slideSpeed: 400,
      // The section open on first init. A number from 1 to X or false.(data-active-index)
      activeIndex: 1,
      // Callback when a section is open
      openSection: function () {
        // console.debug(section);
      },
      // Callback before a section is open
      beforeOpenSection: function () {
        // console.debug(section);
      },
    });

    // Add smooth scrolling to all links
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('[href="javascript:"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 1000, function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            });
          }
        }
      });
    /* ------------------------ Main Navigation dropDown ------------------------ */

    // TODO: This function can be optimized by switching selector and classes to variables.
    function buildDropdown() {
      //Top level items with dropdowns
      const $dropdownParents = $('#header .shop_nav li.has-dropdown');

      //CLOSE ACTIVE DROPDOWN
      $(document).on('mouseup', function (e) {
        //Top active level item
        var $activeParent = $('#header .shop_nav li.has-dropdown.active-dropdown-parent');
        // if the clicked element isn't a top level item
        if (!$activeParent.is(e.target) && $activeParent.has(e.target).length === 0) {
          e.stopPropagation();
          $('body').removeClass('open-overlay');
          //Hide the dropdown menu
          $activeParent.find('.dropdown-menu').addClass('hidden');
          //Remove active mark
          $dropdownParents.removeClass('active-dropdown-parent');
          $dropdownParents.children('a').removeClass('text-primary border-b border-primary').addClass('text-gray-800');
        }
      });
      //OPEN DROPDOWN
      $dropdownParents.on('click', function (e) {
        var clicked = $(e.target.parentNode); //parentNode is required to correctly detect clicks on the children elements.
        e.stopPropagation();
        if ($(this).has(clicked).length === 0) {
          if (isMobile) {
            e.preventDefault(); //Disable top level items href only, allow children to be clickable
          }
          $('body').addClass('open-overlay');
          $(this).addClass('active-dropdown-parent');
          $(this).children('a').removeClass('text-gray-800').addClass('text-primary border-b border-primary');
          $(this).children('.dropdown-menu').removeClass('hidden');
        }
      });
    }
    buildDropdown();

    /* ------------------------------- slickSlider ------------------------------------ */
    // window.addEventListener('load', () => {

    // Peek slider. One visible item.
    // Use a `pl-4` class for the slides.

    function sliderHome() {
      var homeSlider = $('#homeSlider');
      var settingsCompact = {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        fade: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: true,
        lazyLoad: 'ondemand',
        /*responsive: [
          {
            breakpoint: 1024,
            settings: 'unslick',
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],*/
      }
      homeSlider.slick(settingsCompact);
    }

    sliderHome();

    function sliderProductImage() {
      var homeSlider = $('#custom-events-demo');
      var settingsCompact = {
        dots: true,
        arrows: true,
        slidesToShow: 1,
        mobileFirst: true, //NEEDED FOR RESPONSIVE BREAKPOINTS TO WORK CORRECTLY
        autoplay: false,
        autoplaySpeed: 5000,
        fade: true,
        draggable: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: true,
        nextArrow: '<button class="slick-next"><i class="gg-chevron-right-o"></i></button>',
        prevArrow: '<button class="slick-prev"><i class="gg-chevron-left-o"></i></button>',
      }

      homeSlider.on('init', function (event, slick) {
        setTimeout(function () {
          homeSlider.slick('setPosition');
        }, 100);
      });

      homeSlider.slick(settingsCompact);

      $(window).on('load', function() {
        if (homeSlider.hasClass('slick-initialized')) {
          homeSlider.slick('setPosition');
        }
      });
    }

    sliderProductImage();

    function difference() {
      var cards = $('.cards-difference');
      var settingsCompact = {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="gg-chevron-left-o"></i></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="gg-chevron-right-o"></i></button>',
        responsive: [
          {
            breakpoint: 2560,
            settings: 'unslick',
          },
          {
            breakpoint: 1440,
            settings: 'unslick',
          },
          {
            breakpoint: 1024,
            settings: 'unslick',
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '40px',
              centerMode: true,
              arrows: true,
            },
          },
        ],
      }
      cards.slick(settingsCompact);
    }

    difference();


    function reviews() {
      var reviews = $('.list-reviews');
      var settingsCompact = {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '40px',
        centerMode: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 2560,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              centerPadding: '40px',
              centerMode: false,
              arrows: true,
            },
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              centerPadding: '40px',
              centerMode: false,
              arrows: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              centerPadding: '40px',
              centerMode: false,
              arrows: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              centerPadding: '40px',
              centerMode: false,
              arrows: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerPadding: '40px',
              centerMode: true,
              arrows: false,
            },
          },
        ],
      }
      reviews.slick(settingsCompact);
    }

    reviews();

    $('a.play-video').click(function () {
      $('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    });
    $('a.play-video-two').click(function () {
      $('.youtube-video-two')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    });
    $('a.play-video-tree').click(function () {
      $('.youtube-video-tree')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    });
    $('.tapas').click(function () {
      $(this).find('.has-video').hide();
      $(this).find('.video-iframe').show();
    });

    /* ------------------------------- lightGallery ------------------------------- */

    window.addEventListener('load', () => {
      /* eslint-disable */
      lightGallery(document.getElementById('feat_tapas'), {
        selector: '.lg-link',
        thumbnail: false,
      });
      lightGallery(document.getElementById('product-images-carousel'), {
        selector: '.image-zoom',
        thumbnail: false,
      });

      /*$('#product-images-lightbox').click(function () {
        $("#custom-events-demo a:first-child > img").trigger("click");
      });

      const colours = ['#6a7583', '#1e304b', '#315460', '#080607'];
      const galleryEventsDemo = document.getElementById('custom-events-demo');
      galleryEventsDemo.addEventListener('lgBeforeSlide', (event) => {
        const { index } = event.detail;
        document.querySelector('.lg-backdrop').style.backgroundColor =
          colours[index];
      });
      lightGallery(galleryEventsDemo, {
        addClass: 'lg-events-demo-outer', // (Optional)
      });*/
      /* eslint-enable */
    });

    /* -------------------------------- Side Cart ------------------------------- */

    //Trigger open side cart
    $('#header .cart').on('click.sidecart', function sidecart(e) {
      e.stopPropagation();
      e.preventDefault();
      $('body').trigger('side_cart_open');
    });

    //Open side cart
    $('body').on('side_cart_open', function () {
      $('body').addClass('js-side-cart-opened');
      $('.side-cart').addClass('js-side-cart-opened');
    });

    //Trigger close side cart on icon click
    $('.js-side-cart-close').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      $('body').trigger('side_cart_close');
    });
    //Trigger close side cart when clicking outside
    $(document).on('click', function (e) {
      var container = $('.side-cart');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('body').trigger('side_cart_close');
      }
    });
    //Close side cart
    $('body').on('side_cart_close', function () {
      $('body').removeClass('js-side-cart-opened');
      $('.side-cart').removeClass('js-side-cart-opened');
    });

    // Mostrar spinner cuando se empieza a añadir al carrito
    $('body').on('adding_to_cart', function () {
      jQuery('#side-cart-checkout-btn').addClass('is-loading');
    });

    //Added to cart?
    $('body').on('added_to_cart', function () {
      $('body').trigger('side_cart_open');
      console.debug('common.js: Added to cart');

      // Ocultar spinner después de añadir
      jQuery('#side-cart-checkout-btn').removeClass('is-loading');
    });
    var $this;
    if (!$('body').hasClass('single-product')) {
      $(document.body).on('click', '.ajax_add_to_cart', function (event) {
        $this = $(this); // Get button jQuery Object and set it in a variable
        var buttonText = '<span class="add_to_cart_text product-is-added">Adding...</span> <img src="https://nyc3.digitaloceanspaces.com/ibericoclub/prod-iberico/Quick-add-to-cart-Iberico-png-100x100-1.png" style="width: 20px;height: 20px;"  />';

        // Change inner button html (with text) and Change "data-tip" attribute value
        $this.html(buttonText).attr('data-tip', 'Adding...');
      });

      $(document.body).on('added_to_cart', function (event, b, data) {
        var buttonText = '<span class="add_to_cart_text product-is-added">Added</span> <img src="https://nyc3.digitaloceanspaces.com/ibericoclub/prod-iberico/Quick-add-to-cart-Iberico-png-100x100-1.png" style="width: 20px;height: 20px;"  />';

        // Change inner button html (with text) and Change "data-tip" attribute value
        $this.html(buttonText).attr('data-tip', 'Added');
      });
    }

    $('#section-hero-wholehams').click(function () {
      $('html,body').animate({
        scrollTop: $('#product-section-1377').offset().top,
      },
        'slow');
    });

    /**
     * Update mini cart totals on quantity change
     * @source: https://gist.github.com/ashokmhrj/fda5a23f7bdfc55749bd2bd53c64a8ca
     */

    var updateTimeout;
    var updateInProgress = false;
    var pendingUpdate = null;

    jQuery(document).on('change input', '.woocommerce-mini-cart .qty', function (e) {
      var $input = jQuery(this);
      var $cartItem = $input.closest('.woocommerce-mini-cart-item');
      var qty = parseFloat($input.val());

      // Validar cantidad
      if (isNaN(qty) || qty < 0) return;

      // Obtener la 'key' del producto (compatible con varios formatos de name)
      var nameAttr = $input.attr('name');
      var match = nameAttr && nameAttr.match(/cart\[(.*?)\]\[qty\]/);
      var cart_item_key = match ? match[1] : ($input.data('cart_item_key') || $cartItem.data('cart_item_key'));

      if (!cart_item_key) return;

      // Reiniciar temporizador (Debounce)
      if (updateTimeout !== undefined) {
        clearTimeout(updateTimeout);
      }

      // UI OPTIMISTA: Feedback visual inmediato (solo en el item)
      $cartItem.css('opacity', '0.6');
      $input.addClass('loading');

      // Mostrar spinner en botón checkout
      jQuery('#side-cart-checkout-btn').addClass('is-loading');

      // Guardar la actualización pendiente
      pendingUpdate = { cart_item_key: cart_item_key, qty: qty, $cartItem: $cartItem, $input: $input };

      // Esperar 400ms a que el usuario termine de escribir (reducido de 500ms)
      updateTimeout = setTimeout(function () {
        // Si ya hay una petición en progreso, esperar
        if (updateInProgress) {
          return;
        }

        executeUpdate();
      }, 400);
    });

    function executeUpdate() {
      if (!pendingUpdate || updateInProgress) return;

      updateInProgress = true;
      var update = pendingUpdate;
      pendingUpdate = null;

      jQuery.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        timeout: 15000,
        data: {
          action: 'my_update_cart_qty',
          cart_item_key: update.cart_item_key,
          qty: update.qty,
        },
        success: function (response) {
          if (response.fragments) {
            // Reemplazar fragmentos de forma eficiente
            jQuery.each(response.fragments, function (selector, html) {
              var $el = jQuery(selector);
              if ($el.length) {
                $el.replaceWith(html);
              }
            });

            // Disparadores para compatibilidad
            jQuery(document.body).trigger('wc_fragments_refreshed');
            jQuery(document.body).trigger('updated_wc_div');
          }
        },
        error: function () {
          console.error('Error al actualizar cantidad');
          update.$cartItem.css('opacity', '1');
        },
        complete: function () {
          updateInProgress = false;
          // Limpieza final
          jQuery('.woocommerce-mini-cart-item').css('opacity', '1');
          jQuery('.woocommerce-mini-cart .qty').removeClass('loading');

          // Ocultar spinner del botón checkout (solo si no hay más actualizaciones pendientes)
          if (!pendingUpdate) {
            jQuery('#side-cart-checkout-btn').removeClass('is-loading');
          }

          // Si hay otra actualización pendiente, ejecutarla
          if (pendingUpdate) {
            setTimeout(executeUpdate, 100);
          }
        },
      });
    }

    /**
     * Reload page on window resize using a customized method to avoid an iOs bug that reloads the page on scroll
     */
    function reloadOnResize() {

      // Store the window width
      var windowWidth = $(window).width();

      // Resize Event
      $(window).resize(function () {

        // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
        if ($(window).width() != windowWidth) {

          // Update the window width for next time
          windowWidth = $(window).width();

          //location.reload();
          window.location.href = window.location.href;

        }

      });
    }

    //reloadOnResize();

    $('.js-unique-jamon-trigger').modaal({
      content_source: '#unique-jamon-modal',
    });
    function listen_kit_on_click() {
      $('.kit-single').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.debug('[CLICK] first add to cart');
        open_modal();
        //define_product_type(); //Commented this out bc instead of define (again?), let's process it. Having two separate functions should be less confusing

      });
    }
    listen_kit_on_click();
    function setCookie(name, value, expiry) {
      let d = new Date();
      d.setTime(d.getTime() + (expiry * 86400000));
      document.cookie = name + '=' + value + ';' + 'expires=' + d.toUTCString() + ';path=/';
    }
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
    function delete_cookie(name, path, domain) {
      var keyValue = getCookie(name);
      setCookie(name, keyValue, '-1');
    }
    var pageReloaded = window.performance
      .getEntriesByType('navigation')
      .includes('reload');
    if (!getCookie('storageTime')) {
      setCookie('storageTime', new Date().getTime(), 30);
    }
    function isBrowserClosed() {
      /*if (!getCookie('storageTime')) {
        var localStorageTime = setCookie('storageTime', new Date().getTime(), 30);
      } else {
        var localStorageTime = getCookie('storageTime');
      }*/
    }
    /*window.addEventListener('beforeunload', function (e) {
      e.preventDefault();
      if (!pageReloaded) { // The pageReloaded boolean we set earlier
        isBrowserClosed();
      }
    });*/
    function hidden_welcomeback() {
      $('.hidden-wb').on('click', function (e) {
        $('.welcomeback').hide();
        setCookie('wb_user_visit', '', 30);
        delete_cookie('storageTime');
        //define_product_type(); //Commented this out bc instead of define (again?), let's process it. Having two separate functions should be less confusing

      });
    }
    hidden_welcomeback();
    /**
     * Initialize the subscription modal
     * @param {*} add_to_cart_button
     * @param {*} form
     */
    function init_modal() {
      let contador = 0;
      console.debug('[MODAL] init');
      //By hooking the modal to the body, we avoid the plugin adding
      //troublesome behaviors to the add to cart button
      modal = $('body').modaal({
        before_open: function () {
          console.debug('opening modal...');
          $('.modal-kit').removeClass('hidden');
        },
        after_open: function () {
          /*if (product_on_switch) {
            customize_productaddon_form(form_product_on);
            //force_set_buying_option('subscription');
            //get_buying_option_product_on(product_on, form_product_on);
            $('.modaal-content-container').addClass('product_add_on_modal');
          } else {
            customize_subscription_form(form);
            force_set_buying_option('subscription');
            get_buying_option(add_to_cart_button, form);
            
            jQuery('.single_add_to_cart_button').('.Modaal'); //Remove click
          }
          */
        },
        start_open: false,
        fullscreen: false,
        content_source: '.modal-kit',
        before_close: function () {
          console.debug('closing modaal...');
        },
        after_close: function () {
          $('.modal-kit').addClass('hidden');
          //jQuery('.single_add_to_cart_button').modaal('destroy');
          //init_modal(add_to_cart_button, form);
          //jQuery('.single_add_to_cart_button').on('click.Modaal'); //Remove click
          /*if (product_on_switch) {
            $('.product_add_on').off('click#product_add_on');
            listen_product_on_click();
            product_on.show('slow');
            product_add_on.hide();
            $('.product-on-modal').remove();
          } else {
            $('.single_add_to_cart_button').off('click.add_to_cart_from_modal');
            force_set_buying_option('one-time');
            listen_product_click();
          }*/
        },
      });
    }

    /**
     * Open the subscription modal
     * @param object add_to_cart_button
     * @param object form
     */
    function open_modal() {
      if (modal == undefined) {
        init_modal();
      }
      modal.modaal('open');
      console.debug('[MODAL] open');

    }
    function detectMobile() {
      // Detecta si el dispositivo es móvil 
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // Verdadero si es móvil 
        return true;
      }
    }

    $('a img').on('click', function () {
      const $img = $(this);
      const $parent = $img.closest('figure').length ? $img.closest('figure') : $img.parent('a');

      // Prevent multiple loaders
      if ($parent.find('.container-loading').length > 0) return;

      $img.addClass('opacity-loading');
      $parent.css('position', 'relative');
      $parent.append('<div class=\'container-loading\'><span id="loading" class="img-loading"></span></div>');

      setTimeout(function () {
        $img.removeClass('opacity-loading');
        $parent.find('.container-loading').remove();
      }, 3000);
    });
    $('a.btn, a.button, button').not('#custom-events-demo button, #custom-events-demo a.btn, #btn-next-step-2, #btn-next-step-3').on('click', function (e) {
      if ($(this).find('#loading').length === 0) {
        // Si no existe, agregar el elemento a la lista
        $(this).append('<span id=\'loading\'></span>');
      }
    });


    function hideRestaurantLogged() {
      setTimeout(function () {
        $('.logged-restourant').fadeOut('slow');
      }, 10000);
    }
    hideRestaurantLogged();
    function watchAddedProduct() {
      $('.quick-add-cart').click(function () {
        tidioChatApi.track('added-product-cart');
      });
    }
    watchAddedProduct();
    /**
     * Close the subscription modal
     */
    function close_modal() {
      if ($('#no_thanks').length > 0) {
        $('#no_thanks').hide();
      }
      modal.modaal('close');
    }
    $('#header nav.shop_nav ul.nav li.has-dropdown').hover(function () {
      $('.wrap').removeClass('container');
      $('.wrap .content').css({ 'filter': 'brightness(0.1)', 'background': '#000000c4' });
    }, function () {
      $('.page .wrap').addClass('container');
      $('.home .wrap').removeClass('container');
      $('.wrap .content').css({ 'filter': 'none', 'background': 'none' });
    });
    // Variable para prevenir múltiples clics
    var removeItemInProgress = {};

    jQuery(document).on('click', '.my-ajax-remove-item', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = jQuery(this);
      var cart_item_key = $button.data('cart_item_key');

      // Prevenir doble clic
      if (removeItemInProgress[cart_item_key]) {
        return false;
      }
      removeItemInProgress[cart_item_key] = true;

      var $item = $button.closest('.woocommerce-mini-cart-item');
      var $widgetContent = $button.closest('.widget_shopping_cart_content');

      // --- 1. UI OPTIMISTA: Eliminación visual inmediata ---
      $item.css({ 'pointer-events': 'none', 'opacity': '0.3' });

      // Mostrar spinner en botón checkout
      jQuery('#side-cart-checkout-btn').addClass('is-loading');

      // Animación suave para ocultarlo (200ms - más rápido)
      $item.stop().slideUp(200);

      // --- 2. PETICIÓN AL SERVIDOR ---
      jQuery.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        timeout: 15000, // 15 segundos timeout
        data: {
          action: 'my_remove_item',
          cart_item_key: cart_item_key,
        },
        success: function (response) {
          if (response.fragments) {
            // Actualizamos todo el carrito con la info real del servidor
            jQuery(document.body).trigger('removed_from_cart', [response.fragments, response.cart_hash]);

            // Verificamos si el carrito quedó vacío para limpiar cross-sells
            var $new_cart_content = jQuery(response.fragments['div.widget_shopping_cart_content']);
            if ($new_cart_content.find('.woocommerce-mini-cart__empty-message').length > 0) {
              jQuery('#side-cart-cross-sells').fadeOut(200, function () {
                jQuery(this).empty();
              });
            }
            // Los cross-sells se actualizan automáticamente via el evento removed_from_cart
          } else {
            revertRemoval($item);
            console.error('Respuesta inválida del servidor');
          }
        },
        error: function () {
          revertRemoval($item);
          console.error('Error al eliminar producto');
        },
        complete: function () {
          // Limpiar flag de progreso
          delete removeItemInProgress[cart_item_key];
          $widgetContent.removeClass('processing');

          // Ocultar spinner del botón checkout
          jQuery('#side-cart-checkout-btn').removeClass('is-loading');
        },
      });
    });

    /*
    function cambiarTexto() {
      const palabras = ["THANKSGIVING!", "YOUR FALL PARTY!", "CHRISTMAS!"];
      const elemento = document.getElementById("texto-cambiante");
      let indicePalabra = 0;
      let fadeInterval; // Para almacenar el intervalo activo

      const cambiarPalabra = () => {
        elemento.style.opacity = 0; // Reiniciar opacidad antes del cambio
        elemento.textContent = palabras[indicePalabra];

        const fadeIn = () => {
          let opacity = 0;
          fadeInterval = setInterval(() => {
            opacity += 0.05;
            elemento.style.opacity = opacity;
            if (opacity >= 1) {
              clearInterval(fadeInterval);
            }
          }, 20);
        };

        fadeIn();
        indicePalabra = (indicePalabra + 1) % palabras.length;
      };

      // Iniciar con la primera palabra
      cambiarPalabra();

      // Cambiar de palabra cada 6 segundos
      setInterval(cambiarPalabra, 6000);
    }

    cambiarTexto();

    function countdown() {
      const countDownDate = new Date("2024-11-11").getTime();

      const x = setInterval(() => {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.querySelector(".button-countdown").innerHTML = `Ends in ${days} days, ${hours}h:${minutes}m:${seconds}s`;

        if (distance < 0) {
          clearInterval(x);
          document.querySelector(".button-countdown").innerHTML = "EXPIRED";
        }
      }, 1000);
    }

    countdown();*/
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.warn('finalize common');

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js